module.exports = __webpack_public_path__ + "img/matthew.f24ebe1c.png";